import { styles as commonStyles } from '../../../assets/common.scss';
import { styles } from './template.scss';
import { FontSizes, FontWeights } from '../../../types/common/types';
import { ButtonColors, ButtonHeights, ButtonTypes, ButtonFontSizes } from '../../../ui/gzButton/types';

const easmRelatedFindingsTemplate = document.createElement('template');

easmRelatedFindingsTemplate.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <gz-button
    id="back-btn"
    type="${ButtonTypes.QUIET}"
    color="${ButtonColors.SECONDARY}"
    buttonHeight="${ButtonHeights.SMALL}"
    buttonFontSize="${ButtonFontSizes.SMALL}"
  >
    <gz-icon name="ds-icon-arrow_left_collapse" color="${ButtonColors.SECONDARY}" size="24"></gz-icon>

    <span id="back-btn-text"></span>
  </gz-button>

  <div id="easm-related-findings-panel">
    <gz-title id="panel-title" fontWeight="${FontWeights.MEDIUM}" fontSize="${FontSizes.HEADING_5}"></gz-title>

    <div id="panel-container">
      <gz-input-search id="input-search" type="text" maxLength="100"></gz-input-search>

      <div id="finding-groups-container"></div>
    </div>
  </div>
`;

export default easmRelatedFindingsTemplate;
